import {WebHookSendType} from 'shared/__generated__/graphql';

export const SendWebHookType: {
  label: 'POST' | 'GET';
  value: WebHookSendType;
}[] = [
  {label: 'POST', value: WebHookSendType.Post},
  {label: 'GET', value: WebHookSendType.Get},
];
